module.exports = __webpack_public_path__ + "img/text-align-left-01.accbcd70.svg";